import { useState, useEffect } from 'react';

const SHORT_LIST = [
    'AIO Keypad Advanced',
    'AIO Station',
    'Call Cord',
    'Delayed Egress',
    'Door Sensor',
    'Door Sensor with Keypad',
    'Door Sensor with Reset',
    'Doorbell',
    'Fixed Pressure Pad',
    'Mobile Pressure Pad',
    'Motion Detector',
    'Pendant',
    'Pull Cord',
    'Smoke Transmitter',
    'Wandering',
    'Wandering Interface',
    'Wandering Tag',
    'Wandering Transmitter',
    'Wandering Transmitter with Reset',
    'Water Resistant Pendant',
    'Waterproof Pendant',
    'Window Sensor',
];

const DeviceDrawer = ({ open, onClose, onSave, saving, currentDevices, allDevices }) => {
    const [selected, setSelected] = useState([]);
    const [useFullList, setUseFullList] = useState(false);

    // Reset selection when drawer opens
    useEffect(() => {
        if (open) {
            setSelected([...(currentDevices || [])]);
            setUseFullList(false);
        }
    }, [open, currentDevices]);

    // Build display list: short list + any currently selected that aren't in short list
    const getDisplayList = () => {
        if (useFullList) return allDevices || [];
        const merged = [...SHORT_LIST];
        (currentDevices || []).forEach((dev) => {
            if (!merged.includes(dev)) merged.push(dev);
        });
        return merged;
    };

    const displayList = getDisplayList();

    const toggleDevice = (device) => {
        setSelected((prev) =>
            prev.includes(device)
                ? prev.filter((d) => d !== device)
                : [...prev, device]
        );
    };

    return (
        <>
            {open ? <div className="dp-drawer-backdrop" onClick={onClose} /> : null}
            <div className={`dp-drawer dp-drawer--wide${open ? ' is-open' : ''}`}>
                <div className="dp-drawer__header">
                    <h2 className="dp-drawer__title">Edit AFR Devices</h2>
                    <button className="dp-drawer__close" onClick={onClose}>
                        <i className="fe fe-x" />
                    </button>
                </div>
                <div className="dp-drawer__body">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--space-3)' }}>
                        <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)', margin: 0 }}>
                            {selected.length} device{selected.length !== 1 ? 's' : ''} selected
                        </p>
                        <button
                            className="dp-btn dp-btn--secondary dp-btn--sm"
                            onClick={() => setUseFullList(!useFullList)}
                        >
                            {useFullList ? 'See short list' : 'See full list'}
                        </button>
                    </div>

                    <div className="ss-drawer-list">
                        {displayList.map((device) => (
                            <div
                                key={device}
                                className={`ss-drawer-list__item${selected.includes(device) ? ' is-selected' : ''}`}
                                onClick={() => toggleDevice(device)}
                            >
                                {device}
                            </div>
                        ))}
                        {displayList.length === 0 ? (
                            <div className="ss-empty" style={{ padding: 'var(--space-6)' }}>
                                <p className="ss-empty__text">No devices available</p>
                            </div>
                        ) : null}
                    </div>
                </div>
                <div className="dp-drawer__footer">
                    <button className="dp-btn dp-btn--cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="dp-btn dp-btn--primary" disabled={saving} onClick={() => onSave(selected)}>
                        {saving ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </div>
        </>
    );
};

export default DeviceDrawer;
